module.exports = __webpack_public_path__ + "assets/img/login.2ce3fc7f.png";